import React from "react"
import FooterLinks from "./footer-links"
import { Callout, Blurb } from "./footer-styles"
import CalloutImage from "../images/callout.jpg"

const Footer = () => {
  return (
    <footer>
      <p>&copy; LottieMay.co.uk - 2022</p>
      <FooterLinks />
    </footer>
  )
}

export default Footer
